export enum ListViewContentElementControlType {
  ModelProperty = 1,
  CompositeText = 2,
  Formula = 3,
  IconSet = 4,
}
